module.exports = __webpack_public_path__ + "static/team-img-3c0cab3aa2787a21734d7229c0cd0260.png";